export const UIStyledSection: React.FC<{ title: string }> = ({ title, children }) => {
  return (
    <div className="flex flex-col gap-4">
      <div className="p-2 text-center font-bold">{title}</div>
      {children}
    </div>
  );
};
